<div class="col-auto p-5 text-center">
    <img src="assets/img/loader/loader.svg" />
    <h3 class="text-default"> Cargando...</h3>
  </div>
